module.exports = __webpack_public_path__ + "media/images/components/logo-boep-service-a099a044994554166e4e722ea7ff34f3.svg";